// PR-32 — MyCards kart meta yardımcıları (UI-only; ekonomi/motor DEĞİL).
// YALNIZ güvenli public alanlar: rarity, seri, sahiplik adedi, edinme tarihi.
// Gizli alanlar (backing score, eligibility, ledger) BURADA YOK — kart
// dokümanında da bulunmaz, sızma imkânsız.

import { useCallback, useEffect, useRef, useState } from "react";

// EMİR #46 FIX-3 — common ETİKETSİZ. "Klasik" rozeti owner'ı rahatsız etti; kaynak-
// çözüm: rarityLabel common için "" döner → tüm çağrı yerleri koşullu render eder
// (rozet çıkmaz). Görsel kademe (renk/çerçeve/glow) aynen kalır.
// EMİR #60 — kart-evreni taksonomisi globalleşir (mimar hükmü): Nadir→Rare,
// Efsanevi→Legendary. common "" KALIR (Klasik yasağı sürer). TCG kültüründe rarity
// terimleri yerel dilde bile İngilizcedir (koleksiyoncu jargonu).
const RARITY_LABEL: Record<string, string> = {
  common: "",
  rare: "Rare",
  legendaryHidden: "Legendary",
  legendary: "Legendary",
};

export function rarityLabel(rarity?: string | number): string {
  const key = String(rarity || "").trim();
  return RARITY_LABEL[key] ?? "";
}

// CSS rarity-{rarity} sınıfıyla uyumlu normalize (grid ile aynı köken).
export function rarityKey(rarity?: string | number): string {
  const key = String(rarity || "").trim();
  if (key === "legendary") return "legendaryHidden";
  return key || "common";
}

export function seriesLabel(seriesId?: string): string {
  const s = String(seriesId || "").trim();
  if (!s) return "";
  // EMİR #60 — "S1" → "Series 1" (globalize; kart yüzeyi lore). Aksi halde ham göster.
  const m = s.match(/^S(\d+)$/i);
  return m ? `Series ${m[1]}` : s;
}

// Firestore Timestamp | Date | {seconds} → "3 Tem 2026" güvenli format.
// EMİR #80-A.4 — locale parametresi: kart-evreni (arka yüz baskısı) EN olduğu
// için CardBackFace "en-US" ister; TÜM diğer çağrılar default tr-TR'de kalır.
export function formatObtained(ts: any, locale: string = "tr-TR"): string {
  try {
    let d: Date | null = null;
    if (ts?.toDate) d = ts.toDate();
    else if (ts instanceof Date) d = ts;
    else if (typeof ts?.seconds === "number") d = new Date(ts.seconds * 1000);
    if (!d || isNaN(d.getTime())) return "";
    return d.toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

// PR-50 — Kart paylaşımı: /card/:code TEMPLATE permalink'i (Seçenek A). Link
// oturumsuz açılır ve kartın TEMPLATE'ini gösterir (ad/rarity/seri/görsel).
// SAHİPLİK GÖSTERMEZ → metin "benim kartım/kazandım" İDDİA ETMEZ (tarafsız).
// code yoksa güvenli fallback: mevcut sayfa URL'i. Web Share → clipboard.
//
// 🔒 GİZLİLİK KARARI — BU URL `/{u}/cards/{kod}`E YÜKSELTİLMEYECEK (kilitli).
// #863'te kart detay modalına `/{u}/cards/{kod}` adresi verildi ve o adres
// KOLEKSİYONA aittir: "bu kart ŞU KULLANICIDA var" der. Paylaş butonu onu
// üretseydi, kullanıcının her paylaşımı istemsizce bir SAHİPLİK BEYANI olurdu
// — envanter/varlık sızıntısı (kim neye sahip, kim neyi kaçırdı) ve adres
// çubuğundaki iki rotanın anlamı karışırdı:
//    `/card/{kod}`        → kartın kendisi (kim olduğu fark etmez, tarafsız)
//    `/{u}/cards/{kod}`   → BELİRLİ birinin koleksiyonundaki kart
// Paylaşım tarafsız olanı kullanır. Bu davranış `cardMeta.test.ts` içinde
// TESTLE KİLİTLİ — "iyileştirme" niyetiyle kazara değiştirilmesin diye.
// (Kullanıcı kendi koleksiyon adresini paylaşmak isterse zaten adres
// çubuğundan kopyalayabilir; farkı BİLEREK seçer.)
export async function shareCard(item: any): Promise<"shared" | "copied" | "failed"> {
  const name = String(item?.name || item?.code || "MyCard");
  const code = String(item?.code || "").trim();
  const url = code
    ? `${window.location.origin}/card/${encodeURIComponent(code)}`
    : window.location.origin + window.location.pathname;
  const text = `Bu MyLASA kartına göz at: ${name}`;
  try {
    if ((navigator as any).share) {
      await (navigator as any).share({ title: "MyLASA · MyCard", text, url });
      return "shared";
    }
  } catch {
    // kullanıcı iptal etti veya paylaşım başarısız → clipboard'a düş
  }
  try {
    await navigator.clipboard?.writeText(`${text} ${url}`);
    return "copied";
  } catch {
    return "failed";
  }
}

// ─── PR-Next — kutu açılış anı (anticipation beat), UI-only ───────────────────
// Reveal (kutudan yeni çıkan kart) modalinde, kart flip'inden ÖNCE kısa bir
// "kutu açılıyor" beat'i oynatılır → açma heyecanı. Reduced-motion'da veya
// detay (mevcut karta tıklama) görünümünde beat ATLANIR (kart doğrudan görünür).
// Motor/ekonomi/drop mantığına DOKUNMAZ — yalnız görsel faz.

// Beat süresi (ms). Kısa tut: layout'u bloklamaz, sonsuz loading yok.
export const BOX_OPEN_MS = 750;

export function prefersReducedMotion(): boolean {
  try {
    return (
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  } catch {
    return false;
  }
}

export type RevealPhase = "opening" | "card";

// SAF karar: reveal + hareket açık ise "opening" (beat), aksi halde doğrudan
// "card". reduced-motion veya reveal-değil → beat yok.
export function initialRevealPhase(
  isReveal: boolean,
  reducedMotion: boolean,
): RevealPhase {
  return isReveal && !reducedMotion ? "opening" : "card";
}

// Reveal faz makinesi hook'u: mount'ta initialRevealPhase; "opening" ise
// BOX_OPEN_MS sonra "card"a geçer (timeout-bounded → takılmaz). Reveal değil /
// reduced-motion → hemen "card", timer kurulmaz.
export function useRevealPhase(isReveal: boolean): RevealPhase {
  const [phase, setPhase] = useState<RevealPhase>(() =>
    initialRevealPhase(isReveal, prefersReducedMotion()),
  );
  useEffect(() => {
    if (phase !== "opening") return undefined;
    const id = setTimeout(() => setPhase("card"), BOX_OPEN_MS);
    return () => clearTimeout(id);
  }, [phase]);
  return phase;
}

// ─── EMİR #67 P1 + #68a — PREMIUM AÇILIŞ KOREOGRAFİSİ (Kurul-F final) ─────────
// Faz zinciri (JS: useRevealSequence): slam (kutu çarpıp gelir) → charge (mühür
// çatlar + rarity-renk sızması; network+sanat-preload bu fazda gizlenir) →
// [freeze — YALNIZ legendary/1-of-1: 0.3-0.45s tam duruş] → burst (patlama,
// rarity-ölçekli) → card (uçuş+flip+settle). Süre merdiveni (Kurul-F hükmü):
// common ~2.5s · rare ~3.2s · legendary ~4.5s (freeze+ekran-ışını+sarsıntı) ·
// 1/1 ~6s (EVRENSEL AN). KURALLAR: kart flip'i SANAT YÜKLENMEDEN başlamaz
// (artReady) — ama itemReady sonrası ≤ REVEAL_ART_WAIT_CAP_MS bekler, aşarsa
// fallback'le devam (sessiz swap sonra). HER AN dokun = atla (skip → 0.2s
// crossfade ile card). reduced-motion → direkt card (sakin). Detay görünümünde
// (isReveal=false) hiç çalışmaz. Seri akışı: art arda açılışta common kısalır
// (hız hissi), rare+ HER ZAMAN tam kreşendo. UI-only — ekonomi/mint DEĞİŞMEZ.
export type RevealStage = "slam" | "charge" | "freeze" | "burst" | "card";
export type RevealTier = "common" | "rare" | "legendary" | "oneOfOne";
export const REVEAL_SLAM_MS = 250;
export const REVEAL_ART_WAIT_CAP_MS = 2000;
// Rarity-merdiveni süreleri (ms). charge min'i tier BİLİNİNCE uzar (renk sızması
// anticipation'ı); tier gelmeden common tabanı geçerli (spoiler yok).
// Toplamlar (slam+charge+freeze+burst+flip/settle 1100): common ~2.5s ·
// rare ~3.2s · legendary ~4.45s · 1/1 ~5.85s (Kurul-F hedefleriyle hizalı).
const CHARGE_MIN_MS: Record<RevealTier, number> = {
  common: 800, rare: 1450, legendary: 2300, oneOfOne: 3400,
};
const CHARGE_MIN_SERIES_MS = 500; // seri akışında common hızlanır (rare+ asla)
const FREEZE_MS: Record<RevealTier, number> = {
  common: 0, rare: 0, legendary: 300, oneOfOne: 450,
};
const BURST_MS: Record<RevealTier, number> = {
  common: 350, rare: 400, legendary: 500, oneOfOne: 650,
};
export const REVEAL_BURST_MS = BURST_MS.common; // geriye-dönük sabit (testler)
export const REVEAL_CHARGE_MIN_MS = CHARGE_MIN_MS.common;
const REVEAL_TOTAL_CAP_MS = 12_000; // fail-safe: her durumda karta düş
const SERIES_FLOW_WINDOW_MS = 45_000; // art arda açılış penceresi

// Kart meta → koreografi kademesi. 1/1 = editionOf===1 (tek nüsha, evrensel an).
export function revealTier(item: any): RevealTier {
  if (Number(item?.editionOf) === 1) return "oneOfOne";
  const k = rarityKey(item?.rarity);
  if (k === "legendaryHidden") return "legendary";
  if (k === "rare") return "rare";
  return "common";
}

// Seri-akış hafızası (modül-seviye; render'lar arası kalıcı, sekme-lokal).
let _lastRevealAt = 0;
export function noteRevealShown(): void { _lastRevealAt = Date.now(); }

export function useRevealSequence(
  isReveal: boolean,
  itemReady: boolean,
  artReady: boolean,
  tier: RevealTier = "common",
): { stage: RevealStage; skip: () => void; skipped: boolean; replay: () => void } {
  const [stage, setStage] = useState<RevealStage>(() =>
    isReveal && !prefersReducedMotion() ? "slam" : "card",
  );
  const [skipped, setSkipped] = useState(false);
  const chargeStartRef = useRef(0);
  const artCapStartRef = useRef(0);
  const mountRef = useRef(Date.now());
  // Seri akışı: bu reveal, öncekinden kısa süre sonra mı başladı? (mount'ta sabitlenir)
  const seriesQuickRef = useRef(
    _lastRevealAt > 0 && Date.now() - _lastRevealAt < SERIES_FLOW_WINDOW_MS,
  );

  // slam → charge (sabit süre)
  useEffect(() => {
    if (stage !== "slam") return undefined;
    const id = setTimeout(() => {
      chargeStartRef.current = Date.now();
      setStage("charge");
    }, REVEAL_SLAM_MS);
    return () => clearTimeout(id);
  }, [stage]);

  // item (openBlindBox cevabı) gelince sanat-bekleme kapağı saymaya başlar.
  useEffect(() => {
    if (itemReady && !artCapStartRef.current) artCapStartRef.current = Date.now();
  }, [itemReady]);

  // charge → freeze/burst: tier-min süre + item geldi + (sanat hazır VEYA kapak doldu).
  useEffect(() => {
    if (stage !== "charge") return undefined;
    const tick = () => {
      const now = Date.now();
      const minMs = tier === "common" && seriesQuickRef.current
        ? CHARGE_MIN_SERIES_MS
        : CHARGE_MIN_MS[tier];
      const minOk = now - chargeStartRef.current >= minMs;
      const capOk = artCapStartRef.current > 0 && now - artCapStartRef.current >= REVEAL_ART_WAIT_CAP_MS;
      const failSafe = now - mountRef.current >= REVEAL_TOTAL_CAP_MS;
      if (failSafe || (minOk && itemReady && (artReady || capOk))) {
        setStage(FREEZE_MS[tier] > 0 ? "freeze" : "burst");
      }
    };
    tick();
    const id = setInterval(tick, 90);
    return () => clearInterval(id);
  }, [stage, itemReady, artReady, tier]);

  // freeze → burst (legendary/1-of-1 "an durur" beat'i)
  useEffect(() => {
    if (stage !== "freeze") return undefined;
    const id = setTimeout(() => setStage("burst"), FREEZE_MS[tier] || 300);
    return () => clearTimeout(id);
  }, [stage, tier]);

  // burst → card (tier-ölçekli süre; flip CSS'i card girişinde oynar)
  useEffect(() => {
    if (stage !== "burst") return undefined;
    const id = setTimeout(() => setStage("card"), BURST_MS[tier]);
    return () => clearTimeout(id);
  }, [stage, tier]);

  // card'a varış = seri-akış hafızasına damga (bir SONRAKİ açılış hızlanabilir).
  useEffect(() => {
    if (stage === "card" && isReveal) noteRevealShown();
  }, [stage, isReveal]);

  const skip = useCallback(() => { setSkipped(true); setStage("card"); }, []);
  // Tekrar izle: sekansı baştan oynat (kart+sanat zaten hazır → charge tier-min
  // kadar sürer; ekonomi yok, SAF görsel replay).
  const replay = useCallback(() => {
    if (prefersReducedMotion()) return;
    setSkipped(false);
    chargeStartRef.current = 0;
    mountRef.current = Date.now();
    setStage("slam");
  }, []);
  return { stage, skip, skipped, replay };
}

// ─── PR-Showcase — koleksiyon özeti (UI-only; kendi envanterin, SAF) ──────────
// Kullanıcının SAHİP OLDUĞU kartları rarity'ye göre sayar → "sahiplenme/ilerleme
// hissi". total = farklı kart sayısı (grid ile tutarlı). Bu bir ENVANTER sayımı;
// drop oranı / supply / eşik DEĞİL → kanon sızma kuralını çiğnemez. YALNIZ own
// profile'da gösterilir (ziyaretçi koleksiyon büyüklüğü görmez).
export interface CollectionSummary {
  total: number;
  rare: number;
  legendary: number;
}

export function summarizeCollection(
  cards: Array<{ rarity?: string | number }> | null | undefined,
): CollectionSummary {
  const list = Array.isArray(cards) ? cards : [];
  let rare = 0;
  let legendary = 0;
  for (const c of list) {
    const k = rarityKey(c?.rarity);
    if (k === "legendaryHidden") legendary += 1;
    else if (k === "rare") rare += 1;
  }
  return { total: list.length, rare, legendary };
}
